import { useTheme, useMediaQuery } from '@mui/material';
import {
  StyledBentoGridItemContainer,
  StyledBentoGrid,
  StyledBentoGridVideo,
  StyledBentoGridImage,
} from './BentoGrid.styles';
import type {
  BentoGridItemProps,
  CaseStudyBentoGridProps,
} from './BentoGrid.types';

const BentoGridItem = ({ item, isMobile }: BentoGridItemProps) => {
  return (
    <StyledBentoGridItemContainer key={item.id} item={item} isMobile={isMobile}>
      {item.video ? (
        <StyledBentoGridVideo
          item={item}
          muted
          autoPlay
          loop={!!item.loop}
          playsInline>
          <source src={item.media?.url} type="video/mp4" />
          Your browser does not support the video tag.
        </StyledBentoGridVideo>
      ) : (
        <StyledBentoGridImage
          item={item}
          src={item.media?.url}
          alt={item.media?.alternativeText || ''}
        />
      )}
    </StyledBentoGridItemContainer>
  );
};

export const CaseStudyBentoGrid = ({
  columns,
  rows,
  items,
  gap,
}: CaseStudyBentoGridProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <StyledBentoGrid
      columns={columns}
      rows={rows}
      gap={gap}
      isMobile={isMobile}>
      {items.map((item, index) =>
        item ? (
          <BentoGridItem
            key={item.id + index}
            item={item}
            isMobile={isMobile}
          />
        ) : null
      )}
    </StyledBentoGrid>
  );
};
